module.exports = __webpack_public_path__ + "static/media/price-tag.40cd3728.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-tag.svg
// module id = 2095
// module chunks = 33